/* Krudo cart-note autosave.
   Debounced POST to /cart/update.js as the customer types.
   Mirrors button states: idle → SAVING... → SAVED! → idle.
   Uses event delegation so it works on both the cart drawer and the cart
   page, and survives drawer re-renders. */
(function () {
  if (window.KrudoCartNote) return;
  window.KrudoCartNote = true;

  const DEBOUNCE_MS = 500;
  const RESET_MS = 2000;
  const debounceTimers = new WeakMap();
  const resetTimers = new WeakMap();

  function getButton(input) {
    // Same-form button is the canonical pair, but the cart page button
    // lives next to the textarea inside a wrapper, so fall back to a
    // sibling/parent lookup.
    const form = input.form;
    if (form) {
      const btn = form.querySelector('[data-cart-note-btn]') || form.querySelector('.cart__note-btn, .cart-drawer__note-btn');
      if (btn) return btn;
    }
    const field = input.closest('.cart__note-field, .cart-drawer__note-field, [data-cart-note]');
    return field ? field.querySelector('[data-cart-note-btn], .cart__note-btn, .cart-drawer__note-btn') : null;
  }

  function setButtonState(button, state) {
    if (!button) return;
    const input = button
      .closest('.cart__note-field, .cart-drawer__note-field, [data-cart-note]')
      ?.querySelector('[data-cart-note-input], #cart-note, #CartDrawer-Note');
    const idle = input?.dataset.defaultLabel || button.dataset.defaultLabel || 'ADD NOTE';
    const saving = input?.dataset.savingLabel || button.dataset.savingLabel || 'SAVING...';
    const saved = input?.dataset.savedLabel || button.dataset.savedLabel || 'SAVED!';

    if (state === 'saving') {
      button.textContent = saving;
    } else if (state === 'saved') {
      button.textContent = saved;
      clearTimeout(resetTimers.get(button));
      resetTimers.set(
        button,
        setTimeout(() => {
          button.textContent = idle;
        }, RESET_MS)
      );
    } else if (state === 'idle') {
      button.textContent = idle;
    }
  }

  async function save(input) {
    const button = getButton(input);
    setButtonState(button, 'saving');
    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ note: input.value }),
      });
      if (!res.ok) throw new Error('Bad response');
      setButtonState(button, 'saved');
    } catch (e) {
      setButtonState(button, 'idle');
    }
  }

  function handleInput(input) {
    clearTimeout(debounceTimers.get(input));
    debounceTimers.set(
      input,
      setTimeout(() => save(input), DEBOUNCE_MS)
    );
  }

  function updateCounter(input) {
    const field = input.closest('.cart__note-field, .cart-drawer__note-field, [data-cart-note]');
    if (!field) return;
    const counter = field.querySelector('[data-cart-note-counter]');
    if (!counter) return;
    const max =
      parseInt(input.dataset.cartNoteCounterMax || input.getAttribute('maxlength') || '', 10) || null;
    counter.textContent = max ? `${input.value.length} / ${max}` : `${input.value.length}`;
  }

  // Textarea changes
  document.addEventListener('input', (e) => {
    const input = e.target.closest('[data-cart-note-input], #cart-note, #CartDrawer-Note');
    if (!input) return;
    updateCounter(input);
    handleInput(input);
  });

  // Explicit ADD NOTE button click → save immediately
  document.addEventListener('click', (e) => {
    const button = e.target.closest('[data-cart-note-btn], .cart__note-btn, .cart-drawer__note-btn');
    if (!button) return;
    const input = button
      .closest('.cart__note-field, .cart-drawer__note-field, [data-cart-note]')
      ?.querySelector('[data-cart-note-input], #cart-note, #CartDrawer-Note');
    if (!input) return;
    clearTimeout(debounceTimers.get(input));
    save(input);
  });
})();
